window.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    document.querySelectorAll<HTMLAhaToastElement>('aha-toast:not([dismissed])').forEach(toast => {
      toast.dismiss();
    });
  }
});
